import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { get } from "lodash"

import classnames from "classnames"

import Typograph from "../../../../components/Typograph"
import OrderResume from "../../components/OrderResume"
import BreadcrumbRouter from "../../components/Breadcrumb"
import ButtonFixedVoice from "../../components/ButtonFixedVoice"

import styles from "./styles.css"

import { TYPE_OF_SALE } from "../NewSale/constants"

import iconFlag from "../../../../assets/svg/fixed_voice_dash_flag.svg"
import iconPlus from "../../../../assets/svg/fixed_voice_plus.svg"

import OrderStatus from "./OrderStatus"

const ConfirmScreen = ({ history, order, response }) => {
  const message = get(response, "message", null)
  const requestId = message ? message.split("-")[1] : "não informado"
  const protocolo = get(response, "protocolo", null)
  const typeOfSale = get(order, "typeOf", "")
  const assigneeName = get(order, "assigneeName", "")
  const assigneeDoc = get(order, "assigneeDoc", "")
  const uf = get(order, "uf", "")
  const areaLocal = get(order, "areaLocal", "")
  const locality = get(order, "locality", "")
  const qnt = get(order, "qnt", "")
  const phonesPortability = get(order, "phonesPortability", [])

  const typeOfResponse = get(order, "typeOfResponse", "")
  const category = get(order, "category", "não informado")

  const isPortability = typeOfSale === TYPE_OF_SALE.PORTABILITY.TITLE
  const isSpecialistAnalyst = typeOfResponse === "SPECIALIST"
  const isSuspension = category === "Suspensão"

  const title = isPortability
    ? "Pedido de portabilidade realizado com sucesso!"
    : "Venda realizada com sucesso!"

  const infoSuspension = isSpecialistAnalyst && isSuspension

  const orderValues = {
    assigneeName,
    assigneeDoc,
    uf,
    areaLocal,
    locality,
    qnt,
    phonesPortability
  }

  useEffect(() => {
    if (!order) {
      history.push({
        pathname: "/fixed-voice"
      })
    }
  }, [order])

  return (
    <div className={styles.fixedVoice}>
      <BreadcrumbRouter hiddenButton />
      <div className={styles.containerBoxSuccess}>
        <div
          className={classnames({
            [styles.columnSpecialist]: isSpecialistAnalyst
          })}
        >
          {isSpecialistAnalyst ? (
            <div className={styles.button_container}>
              <Typograph
                htmlTag="h1"
                size="x_large"
                color="outer_space"
                weight="bold"
              >
                Sua solicitação foi recebida!
              </Typograph>

              <ButtonFixedVoice
                name={"Criar nova análise de especialista"}
                linkName={"specialist-analysis"}
                icon={iconFlag}
                isOutline={true}
              />
            </div>
          ) : (
            <div className={styles.headerConfirm}>
              <Typograph
                htmlTag="h1"
                size="x_large"
                color="outer_space"
                weight="bold"
                classNames={styles.titleHeader}
              >
                {title}
              </Typograph>
              <ButtonFixedVoice
                name={"Cadastrar outra venda"}
                linkName={"new-sale"}
                icon={iconPlus}
                hasBackgroundLink
                className={styles.newSaleButton}
              />
            </div>
          )}

          <OrderStatus
            infoSuspension={infoSuspension}
            category={category}
            quantityOfNumbers={qnt}
            assigneeName={assigneeName}
            isPortability={isPortability}
            isSpecialistAnalyst={isSpecialistAnalyst}
            requestId={requestId}
            protocolo={protocolo}
          />
        </div>
      </div>

      {!isSpecialistAnalyst && (
        <div className={styles.columnsResume}>
          <OrderResume
            formValues={orderValues}
            typeOfSale={typeOfSale}
            saleDone={true}
          />
        </div>
      )}
    </div>
  )
}

ConfirmScreen.propTypes = {
  history: PropTypes.object,
  order: PropTypes.object,
  response: PropTypes.object
}

const mapStateToProps = ({ newOrder }) => ({
  order: newOrder.order,
  response: newOrder.response
})

export default connect(mapStateToProps)(ConfirmScreen)



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/ConfirmScreen/index.js